import React, {useEffect, useState} from "react";
import SearchTable from "../../../primer/Search-Table";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {useDispatch, useSelector} from "react-redux";
import {fetchAdvancedTypes} from "../../../../_apis/api";
import {useTranslation} from "../../../../hooks/useTranslation";

const SupplierMovementsSearch = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const company = useSelector((state) => state.COMPANY_DATA.company);

    useEffect(() => {
        dispatch(fetchAdvancedTypes({company: company.id}))
    }, []);

    const getDocumentTypes = () => {
        const docTypes = [...advancedTypes.filter((el) => el.section === "Supplier Movements")];
        let advOptions = [];
        for (let doc of docTypes) {
            advOptions.push({value: doc._id, label: doc.name})
        }
        return advOptions;
    }

    const searchSupplierFilters = {
        filters: [
            {
                name: "name",
                label: t("General.supplierName"),
                type: "input",
            },
            {
                name: "sum_from",
                label: t("General.totalSumFrom"),
                type: "input",
            },
            {
                name: "sum_to",
                label: t("General.totalSumTo"),
                type: "input",
            },
            {
                name: "documentType",
                label: t("General.documentType"),
                type: "multiselect",
                options: getDocumentTypes(),
            },
            {
                name: "numberFrom",
                label: t('General.numberFrom'),
                type: "number",
            },
            {
                name: "numberTo",
                label: t('General.numberTo'),
                type: "number",
            },
        ],
    };
    const scColumns = [
        {
            name: t("General.date"),
            field: "date",
            editable: false,
            inputType: {
                type: 'date',
            }
        },
        {
            name: t("General.documentType"),
            field: "documentTypeName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.reason"),
            field: "reason",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.totalAmount"),
            field: "sum",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
    ]
    const [tableColumns, setTableColumns] = useState(scColumns.slice());

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    return (
        <div>
            <SearchTable
                tableName="Supplier Movements Search"
                key={"Supplier Movements Search"}
                allowPagination={true}
                hideYearFilter={false}
                allowToggleColumns={true}
                allowPrintResults={true}
                dataEndpoint={"/supplier/master-supplier-movement-search"}
                exportFileName={"Κινήσεις Προμηθευτών"}
                columns={tableColumns}
                toggleColumns={handleColumnShowHide}
                data={[]}
                filtersConfig={searchSupplierFilters}
            />
        </div>
    )
}

export default SupplierMovementsSearch;
